import React from "react";
import { FaShoppingBag } from "react-icons/fa";
import fallbackImg from "../../assets/logo/appstore.png";

export default function OrderDetailsDrawer({ order, onClose }) {
  if (!order) return null;

  const getStatusStyle = (status) => {
    switch (status) {
      case "Delivered":
        return "bg-green-100 text-green-600";
      case "Scheduled":
        return "bg-yellow-100 text-yellow-600";
      case "Cancelled":
        return "bg-red-100 text-red-600";
      default:
        return "bg-blue-100 text-blue-600";
    }
  };

  return (
    <>
      {/* OVERLAY */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[1100] flex items-center justify-center"
        onClick={onClose}
      >
        {/* MODAL */}
        <div
          onClick={(e) => e.stopPropagation()}
          className="w-[95%] max-w-lg max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col animate-[fadeIn_0.3s_ease]"
        >
          {/* HEADER */}
          <div className="sticky top-0 bg-gradient-to-r from-red-500 via-pink-500 to-orange-400 text-white p-4 flex justify-between items-center">
            <div className="flex items-center gap-2">
              <FaShoppingBag className="text-lg" />
              <h2 className="font-bold text-lg">
               Order Details
              </h2>
            </div>

            <button
              onClick={onClose}
              className="text-xl hover:scale-110 transition"
            >
              ✕
            </button>
          </div>

          {/* BODY */}
          <div className="flex-1 overflow-y-auto p-4 space-y-4">

            {/* STATUS */}
            <span
              className={`inline-block px-3 py-1 text-xs rounded-full font-medium ${getStatusStyle(
                order?.status
              )}`}
            >
              {order?.status || "Unknown"}
            </span>

            {/* SUMMARY */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl shadow-sm">
              <h3 className="font-semibold mb-2 text-gray-800">
                Order Summary
              </h3>

              <div className="text-sm text-gray-600 space-y-1">
                <p><strong>Order No:</strong> {order?.orderNumber}</p>
                <p>
                  <strong>Date:</strong>{" "}
                  {order?.orderDate
                    ? new Date(order.orderDate).toLocaleString()
                    : "-"}
                </p>
                <p>
                  <strong>Total Items:</strong>{" "}
                  {order?.totalQuantity || 0}
                </p>
              </div>

              <p className="mt-3 text-lg font-bold text-red-500">
                ₹{order?.finalAmount || 0}
              </p>
            </div>

            {/* ITEMS */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl shadow-sm">
              <h3 className="font-semibold mb-3 text-gray-800">
                Items
              </h3>

              {order?.items?.length > 0 ? (
                order.items.map((item, i) => (
                  <div
                    key={i}
                    className="flex gap-3 mb-3 pb-3 border-b last:border-none"
                  >
                    <img
                      src={fallbackImg}
                      className="w-16 h-16 object-cover rounded-lg border"
                      alt="product"
                    />

                    <div className="flex-1">
                      <p className="font-medium text-sm text-gray-800">
                        {item?.itemName ||
                          `Product #${item?.ProductId}`}
                      </p>

                      <p className="text-xs text-gray-500 mt-1">
                        Qty: {item?.Quantity || 0}
                      </p>

                      <p className="text-green-600 font-semibold text-sm mt-1">
                        ₹{item?.UnitPrice || 0}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-400">
                  No items found
                </p>
              )}
            </div>

            {/* PRICE DETAILS */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl shadow-sm">
              <h3 className="font-semibold mb-3 text-gray-800">
                Price Details
              </h3>

              <div className="flex justify-between text-sm mb-2 text-gray-600">
                <span>Subtotal</span>
                <span>₹{order?.subTotal || 0}</span>
              </div>

              <div className="flex justify-between text-sm mb-2 text-gray-600">
                <span>Discount</span>
                <span className="text-green-600">
                  ₹{order?.discountAmount || 0}
                </span>
              </div>

              <hr className="my-2" />

              <div className="flex justify-between font-semibold text-base">
                <span>Total Paid</span>
                <span className="text-red-500">
                  ₹{order?.finalAmount || 0}
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ANIMATION */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </>
  );
}